var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[this.currentLanguage == 'AR' ? 'rtlText': '']},[_c('Header'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('Footer',{attrs:{"color":_vm.helpers.accent_color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }